import React, { useCallback } from 'react';

import { RightSideDialog } from '../common/RightSideDialog';
import { PlexPostDetails } from './post/PlexPostDetails';
import { PlexQuestionDetails } from './question/PlexQuestionDetails';
import { PlexTaskDetails } from './task/PlexTaskDetails';
import { usePlexRoute } from './usePlexRoute';

export const DetailsDrawer = React.memo((): React.ReactElement | null => {
  const [plexRoute, updatePlexRoute] = usePlexRoute();

  const onChangeCommentsVisibility = useCallback(
    (commentsVisible: boolean): void => {
      if (plexRoute?.selectedItem?.type === 'post' || plexRoute?.selectedItem?.type === 'question') {
        updatePlexRoute({ selectedItem: { ...plexRoute.selectedItem, commentsVisible } });
      }
    },
    [plexRoute, updatePlexRoute]
  );

  const onClose = useCallback(() => {
    updatePlexRoute({ selectedItem: undefined });
  }, [updatePlexRoute]);

  return (
    <RightSideDialog open={plexRoute?.selectedItem != null} onClose={onClose}>
      {plexRoute?.selectedItem?.type === 'post' && (
        <PlexPostDetails
          plexPost={{
            permalink: plexRoute.selectedItem.permalink,
            commentsVisible: !!plexRoute.selectedItem.commentsVisible,
          }}
          onChangeCommentsVisibility={onChangeCommentsVisibility}
        />
      )}
      {plexRoute?.selectedItem?.type === 'question' && (
        <PlexQuestionDetails
          plexQuestion={{
            permalink: plexRoute.selectedItem.permalink,
            commentsVisible: !!plexRoute.selectedItem.commentsVisible,
          }}
          onChangeCommentsVisibility={onChangeCommentsVisibility}
        />
      )}
      {plexRoute?.selectedItem?.type === 'task' && <PlexTaskDetails taskPermalink={plexRoute.selectedItem.permalink} />}
    </RightSideDialog>
  );
});
